// src/components/common/SketchButton.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk } from '@/icons';
import LoadingButton from './LoadingButton';
import './SketchButton.css';

interface SketchButtonProps {
  isLoading: boolean;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

const SketchButton: React.FC<SketchButtonProps> = ({
  isLoading,
  onClick,
  disabled = false,
  className = '',
}) => {
  return (
    <LoadingButton
      isLoading={isLoading}
      onClick={onClick}
      disabled={disabled}
      className={`sketch-button ${className}`}
    >
      <FontAwesomeIcon icon={faFloppyDisk} /> Rascunho
    </LoadingButton>
  );
};

export default SketchButton;
